import {ImArrowDown, ImArrowDownRight, ImArrowRight, ImArrowUp, ImArrowUpRight} from "react-icons/im";

type Props = {
    a: number;
    b: number;
};
const ArrowIconComponent: React.FC<Props> = ({ a, b }) => {
    let difference: number | 0 = parseFloat((b - a).toFixed(2));

    if (difference >= 1) {
        return <ImArrowUp size={65} color={'#014493'}/>;
    } else if (difference <= -1) {
        return <ImArrowDown size={65} color={'#014493'}/>;
    } else if (difference > 0.2) {
        return <ImArrowUpRight size={65} color={'#014493'}/>;
    } else if (difference < -0.2) {
        return <ImArrowDownRight size={65} color={'#014493'}/>;
    } else {
        return <ImArrowRight size={65}  color={'#014493'}/>;
    }
};

export default ArrowIconComponent;
